import React from "react";
import PropTypes from "prop-types";
import { Badge, CellText } from "@opendate-app/setlist";
import { FansCount, ViewLink } from "./SegmentRow";

const AudiencePill = ({ audience, teamId }) => (
  <a href={`/teams/${teamId}/segments/${audience.segment_id}`} style={{ textDecoration: "none" }}>
    <Badge size="sm">
      <span style={{ color: "var(--sl-text-tertiary)" }}>{audience.label}</span>{" "}
      <span style={{ color: "var(--sl-text-primary)", fontWeight: 600 }}>{Number(audience.count || 0).toLocaleString()}</span>
    </Badge>
  </a>
);

AudiencePill.propTypes = {
  audience: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
    segment_id: PropTypes.number,
    count: PropTypes.number,
  }).isRequired,
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export const eventAudienceColumns = (teamId, header) => [
  {
    key: "event",
    header,
    primary: true,
    width: "240px",
    render: (event) => (
      <a href={`/teams/${teamId}/confirms/${event.id}`} style={{ textDecoration: "none" }}>
        <CellText primary={event.title} supporting={event.date} />
      </a>
    ),
  },
  {
    key: "audiences",
    header: "Audiences",
    render: (event) => (
      <span style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {event.audiences.map((audience) => <AudiencePill key={audience.key} audience={audience} teamId={teamId} />)}
      </span>
    ),
  },
  { key: "total_fans", header: "Fans", align: "right", width: "120px", render: (event) => <FansCount count={event.total_fans} /> },
  {
    key: "view",
    header: "",
    align: "right",
    width: "80px",
    render: (event) => <ViewLink href={`/teams/${teamId}/confirms/${event.id}`} label={`View ${event.title}`} />,
  },
];
